export { GreenhouseListings } from './component-legacy'

export interface IProps {
  title: string
  noResults: string
  data: IJobData
  roleFilter?: string
  orgFilter?: string
  ghSrcToken?: string
}

export const officeIds: Record<string, number> = {
  chicago: 15648,
  dublin: 8185,
  london: 24815,
  'san-francisco': 8184,
  sydney: 21421,
}

export interface IDepartment {
  id: number
  name: string
  parent_id: number | null
  child_ids: number[]
  jobs: IJob[]
}

export interface IOffice {
  id: number
  name: string
  location: string | null
  parent_id: number | null
  child_ids: number[]
  departments: IDepartment[]
}

export interface IJob {
  absolute_url: string
  internal_job_id: number
  location: {
    name: string
  }
  data_compliance?: {
    type: string
    requires_consent: boolean
    retention_period: number | null
  }[]
  metadata: []
  id: number
  updated_at: string
  requisition_id: number | null
  title: string
}

export interface IJobData {
  offices: IOffice[]
}

export interface IFilter {
  value: string
  label: string
  checked: boolean
}
